module.exports = __webpack_public_path__ + "img/bow.8476806d.png";